import redirectsData from '~/redirects.json'

export default defineNuxtRouteMiddleware((to, from) => {
  // Get the current path without query params and hash
  const currentPath = to.path

  // Check if current path exists in redirects
  if (currentPath in redirectsData) {
    const newPath = redirectsData[currentPath as keyof typeof redirectsData]

    // Preserve query params and hash if they exist
    const fullNewPath = {
      path: newPath,
      query: to.query,
      hash: to.hash
    }

    // Perform redirect with 301 status code
    return navigateTo(fullNewPath, { redirectCode: 301 })
  }
})
